// framework/client/components/InviteCodeManager.js
import { ComponentBase } from "../core/ComponentBase.js";

export class InviteCodeManager extends ComponentBase {
    constructor(config) {
        super(config);
        this.dataCrud = null;
    }

    async initialize() {
        this.dataCrud = await this.createManagedComponent("DataCrud", null, {
            eventGroup: `${this.config.instanceId || 'inviteCodeManager'}-crud`,
            rpcClass: "InviteCodeRpc",
            schemaPath: "collections/inviteCodes",
            title: "Invite Code Management",
            viewConfig: {
                mode: 'grid',
                fields: [
                    { name: 'code', label: 'Code', render: (val) => `<code>${val}</code>` },
                    { name: 'notes', label: 'Notes' },
                    { name: 'usage', label: 'Usage', render: (val, item) => `${item.currentUses} / ${item.maxUses}` },
                    { name: 'isEnabled', label: 'Enabled', render: (val) => val ? '<i class="bi bi-check-circle-fill text-success"></i>' : '<i class="bi bi-x-circle text-muted"></i>' },
                    { name: 'expiresAt', label: 'Expires', render: (val) => val ? new Date(val).toLocaleDateString() : 'Never' },
                ],
                toolbar: { create: { enabled: true, label: "Generate Code" } }
            },
            formConfig: {
                mode: 'edit',
                fields: {
                    code: { type: 'text', label: 'Invite Code', required: true },
                    maxUses: { type: 'number', label: 'Maximum Uses', required: true },
                    notes: { type: 'textarea', label: 'Notes / Purpose', rows: 2 },
                    isEnabled: { type: 'boolean', label: 'Enable this code', default: true },
                    expiresAt: { type: 'date', label: 'Expiration Date (Optional)' },
                }
            },
            dataConfig: {
                autoLoad: false
            }
        });
        await super.initialize();
    }

    async initAfterLogin() {
        if (this.dataView) {
            await this.dataView.refreshData();
        }
    }

    async render() {
        return await this.dataCrud.render();
    }

    destroy() {
        this.dataCrud?.destroy();
        this.dataCrud = null;
        super.destroy();
    }
}